// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__n7Pp0","button":"styles_button__5cxKK"};